import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { getCookie } from './components/login/cookies';
import LoginPage from './routes/login/LoginPage';
import HomePage from './components/sidebar/homePage';
import DashboardMain from './routes/dashboard/dashboardMain';
import BulkUploadTask from './routes/bulkupload/bulkUploadTask';
import ProjectListMain from './routes/projects/projectListMain';
import ProjectMain from './routes/addProject/projectMain';
import ExpertMain from './routes/addexpert/expertsMain';
import ExpertListMain from './routes/experts/expertListMain';
import ProjectTab from './components/projectList/projectListTab';
import UserMain from './routes/adduser/userMain';
import UserListMain from './routes/users/userListMain';
import ConfigMain from './routes/addConfig/configMain';
import TaskUploadMain from './routes/uploadtask/taskUploadMain';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './redux/store/appStore';
import { getUserAccess } from './redux/slices/company';
import TaskCompletedMain from './components/taskCompleted/taskCompletedMain';
import CustomizedSteppers from './components/multiStepAllocation/multiStepAllocation';
import VendorManagment from './components/vendorList/VendorListMain';
import AddVendor from './components/vendor/VendorFormHeading';
import VendorMain from './routes/vendorForm/VendorMain';
import VendorAllocationSteps from './components/vendorBulkAllocation/multiStepVendorAllocation';
import DeliveredTaskUploadMain from './components/taskDelivered/deliveredTaskUploadMain';

import VendorUnallocationSteps from './components/vendorBulkUnallocation/multiStepVendorUnallocation';
import TestQuestionsMain from './components/projectTest/testQuestions/testQuestionsMain';
import ReviewMain from './components/reviewer/reviewMain';
import UploadQuestionsMain from './components/Upload Bulk Questions/UploadQuestionsMain';
import JsonMultiStepExport from './components/outputJson/jsonMultiStepExport';
// import BulkTaskDelete from './components/uploadTask/BulkTaskDelete';
import BulkTaskDeleteMain from './components/uploadTask/BulkTaskDeleteMain';
import WorkflowMain from './components/Workflow/workflowMain';
import CreateFeedbackPage from './components/feedback/CreateFeedbackPage';
import AiValidationHistory from './components/HistoryLogs/AiValidationHistory';
import RunScriptMain from './components/runScript/RunScriptMain';
import ScriptExecutionPage from './routes/scriptExecution/ScriptExecutionPage';



const AppRoutes: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const dashboardAccess = useSelector((state: RootState) => state.company.company.data.modules.dashboard)

  useEffect(() => {
    const authToken = getCookie("token");
    if (!authToken) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const authToken = getCookie("token");
    if (authToken) {
      dispatch(getUserAccess({}));
    }
  }, [getCookie("token")]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/project/:id/ai-validation-history" element={<AiValidationHistory />} />
      <Route path="/" element={<HomePage />}>
        { dashboardAccess != null && dashboardAccess.access === true &&
          <Route path="/dashboard" element={<DashboardMain />} />
        }
        <Route path="adduser" element={<UserMain />} />
        <Route path="adduser/:id" element={<UserMain />} />
        <Route path="users" element={<UserListMain />} />
        <Route path="experts" element={<ExpertListMain />} />
        <Route path="addexpert" element={<ExpertMain />} />
        <Route path="addexpert/:id" element={<ExpertMain />} />
        <Route path="addproject" element={<ProjectMain />} />
        <Route path="addproject/:id" element={<ProjectMain />} />
        <Route path="projects" element={<ProjectListMain />} />
        <Route path="project/:id" element={<ProjectTab />} />
        <Route path="bulkupload" element={<BulkUploadTask />} />
        <Route path="/bulktaskdelete/:id" element={<BulkTaskDeleteMain/>}/>
        <Route path="addconfig/:id" element={<ConfigMain/>} />
        <Route path="editconfig/:id/:configId/:configRowId/" element={<ConfigMain/>} />
        <Route path="uploadtask/:id" element={<TaskUploadMain/>} />
        <Route path="exportjson/:id" element={<JsonMultiStepExport/>} />
        <Route path="/task/:id/:taskId" element={<TaskCompletedMain />} />
        <Route path="/allocation/:id/:option" element={<CustomizedSteppers />} />
        <Route path="/vendorbulkallocation/:id" element={<VendorAllocationSteps />} />
        <Route path="/vendorbulkunallocation/:id" element={<VendorUnallocationSteps />} />
        <Route path="/deliveredTask/:id" element={<DeliveredTaskUploadMain />} />
        <Route path="vendors" element={<VendorManagment />} />
        <Route path='/addvendor' element={<VendorMain />} />
        <Route path='addvendor/:id' element={<AddVendor />} />
        <Route path='addtest/:id' element={<TestQuestionsMain />} />
        <Route path='edittest/:id/:configId/:configRowId/' element={<TestQuestionsMain />} />
        <Route path='addReviewer/:id' element={<ReviewMain />} />
        <Route path='editReviewer/:id/:reviewerId' element={<ReviewMain />} />
        <Route path='uploadQuestions/:id' element={<UploadQuestionsMain />} />
        <Route path='/createWorkflow/:id' element={<WorkflowMain/>}/>
        <Route path='/createWorkflow/:id/:workflowId' element={<WorkflowMain/>}/>
        <Route path='addfeedback/:id' element={<CreateFeedbackPage/>}/>
        <Route path="/feedback/edit/:id/:feedbackId" element={<CreateFeedbackPage />} />
        <Route path="/runscript/:id" element={<RunScriptMain />} />
        <Route path="/script-execution" element={<ScriptExecutionPage />} />

        {/* <Route path='test/:id' element={<TestQuestionsMain/>} /> */}
      </Route>
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;

